// src/components/WildfireAlertsProvider.js
import { useEffect } from "react";
import { useAlerts } from "../context/AlertsContext";
import { useWildfireAlerts } from "../hooks/useWildfireAlerts";

const WildfireAlertsProvider = function WildfireAlertsProvider(props) {
  const bufferMiles = props && props.bufferMiles != null ? props.bufferMiles : 25;
  const { wildfireAlerts, wildfireError } = useWildfireAlerts({
    bufferMiles: bufferMiles,
  });
  const { setWildfireAlerts } = useAlerts();

useEffect(
  function () {
    setWildfireAlerts((current) => {
      const next = wildfireAlerts || [];

      if (
        current.length === next.length &&
        current.every((item, index) => item === next[index])
      ) {
        return current;
      }

      console.log(
        "[WildfireAlertsProvider] updating wildfire alerts:",
        next.length
      );

      return next;
    });
  },
  [wildfireAlerts, setWildfireAlerts]
);

  useEffect(
    function () {
      if (wildfireError) {
        // console.error("WildfireAlertsProvider error:", wildfireError);
      }
    },
    [wildfireError]
  );

  return null;
};

export default WildfireAlertsProvider;
